import axios from '@/utils/api.request'
// import axios from 'axios'
let previousUrl = '/api'

export const uploadFile = (formData, file) => {
  return axios.request({
    url: `${previousUrl}/file/Upload`,
    data: formData,
    // headers: {
    //   'userId': userId
    // },
    method: 'post',
    onUploadProgress: progressEvent => {
      const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
      file.onProgress({ percent: complete })
    }
  })
}
export const uploadFiles = (formData) => {
  return axios.request({
    url: `${previousUrl}/file/Uploads`,
    data: formData,
    method: 'post'
  })
}
